export default __webpack_public_path__ + "static/right-3428caabc3e357e0ec1fea56fc6bf6c7.gif";